import React from 'react';

import { FiqlSearch, OrdIconStandard } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { dataSchema } from '@ragu-components/ord-types';

import { AssignedResourceList } from './AssignedList';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type {
  AssignedInboundE164Read,
  AssignedSipProfileRead,
  AssignedLcrRead,
  AssignedCarrierRead,
} from '@ragu-components/ord-types';

// Since AssignedResourceList is very simple
// And is shared by multiple resources
// it doesn't make sense to load it lazily

export const assignedCarriersResource: OrdResourceProps = {
  key: Resources.assigned_carriers,
  name: Resources.assigned_carriers,
  list: (
    <AssignedResourceList
      icon={<OrdIconStandard name='carriers' />}
      headerChildren={<FiqlSearch schema={dataSchema.AssignedCarrierRead.title} />}
    />
  ),
  options: {},
  recordRepresentation: (record: AssignedCarrierRead): string => record.name,
};

export const assignedSipProfilesResource: OrdResourceProps = {
  key: Resources.assigned_sip_profiles,
  name: Resources.assigned_sip_profiles,
  list: (
    <AssignedResourceList
      icon={<OrdIconStandard name='sipProfiles' />}
      headerChildren={<FiqlSearch schema={dataSchema.AssignedSipProfileRead.title} />}
    />
  ),
  options: {},
  recordRepresentation: (record: AssignedSipProfileRead): string => record.name,
};

export const assignedLcrsResource: OrdResourceProps = {
  key: Resources.assigned_lcrs,
  name: Resources.assigned_lcrs,
  list: (
    <AssignedResourceList
      icon={<OrdIconStandard name='lcrs' />}
      headerChildren={<FiqlSearch schema={dataSchema.AssignedLcrRead.title} />}
    />
  ),
  options: {},
  recordRepresentation: (record: AssignedLcrRead): string => record.name,
};

const AssignedInboundE164sResource = React.lazy(async () => import('./AssignedInboundE164sResource'));

export const assignedInboundE164sResource: OrdResourceProps = {
  key: Resources.assigned_inbound_e164s,
  name: Resources.assigned_inbound_e164s,
  list: (
    <AssignedInboundE164sResource
      icon={<OrdIconStandard name='inboundE164s' />}
      headerChildren={<FiqlSearch schema={dataSchema.AssignedInboundE164Read.title} />}
    />
  ),
  options: {},
  recordRepresentation: (record: AssignedInboundE164Read): string => record.e164_match,
};
